import BaseFormController from './base_form_controller'

export default class extends BaseFormController {
  connect() {
    super.connect()
  }
}
